<div class="contentWrapper">
  <div class="logo">
    <img [src]="configService.logoPath" alt="Logo" width="200">
  </div>
  <div class="messageWrapper">
    <h4>Sorry, some error occured, please try again later</h4>
    <p>Please click here to <a (click)="RedirectToLogin()">Login</a> again</p>
  </div>
</div>